import { NgModule } from '@angular/core';
import * as MapboxGl from 'mapbox-gl';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';

import { ConsoleService } from 'src/app/core/services/console.service';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { MaterialModule } from 'src/app/shared/modules/material/material.module';
import { environment } from 'src/environments/environment';
import { ShortLinksMapControlComponent } from './short-links-map-control.component';

if (MapboxGl.getRTLTextPluginStatus() === 'unavailable')
  MapboxGl.setRTLTextPlugin(
    'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.0/mapbox-gl-rtl-text.js',
    (err: any) => {
      err && ConsoleService.error('', err);
    },
    true,
  );

@NgModule({
  declarations: [ShortLinksMapControlComponent],
  imports: [
    MaterialModule,
    BaseFormModule,
    NgxMapboxGLModule.withConfig({
      accessToken: environment.mapBoxToken,
    }),
  ],
  exports: [ShortLinksMapControlComponent],
})
export class ShortLinksMapControlModule {}
